import React from "react";

import { ScimLogModelFrontend } from "@performyard/service-contracts";

import Button from "../../../../../components/Button";
import ContentModal from "../../../../../components/Modal/Templates/ContentModal";
import Typography from "../../../../../components/Text";
import FormattedLogDetails from "./FormattedLogDetails";

import { capitalizeWord } from "../../../../../utils/stringUtils";

import css from "../ScimLog.module.scss";

interface ScimDetailsModalProps {
	isOpen: boolean;
	handleClose: () => void;
	scimLog: ScimLogModelFrontend | null;
}

// Returns details modal title based on scim log type
// with custom title when log status is failed and type is unknown
const getModalTitle = (scimLog: ScimLogModelFrontend) => {
	if (scimLog.status !== "completed" && scimLog.scimLogType === "unknown") {
		return "General Failures";
	} else {
		return capitalizeWord(scimLog.scimLogType);
	}
};

// Returns details modal subtitle based on scim log type
// with no subtitle for failed syncs
const getModalSubtitle = (scimLog: ScimLogModelFrontend) => {
	if (scimLog.status === "completed") {
		switch (scimLog.scimLogType) {
			case "create":
				return "The following fields were created";
			default:
				return "The following fields were modified";
		}
	}

	return "";
};

const ScimDetailsModal = ({ isOpen, handleClose, scimLog }: ScimDetailsModalProps) => {
	if (scimLog) {
		return (
			<ContentModal
				size="small"
				contentClassName={css.modalContentContainer}
				isOpen={isOpen}
				handleClose={handleClose}
				title={
					<Typography size="sub-heading" weight="semi-bold">
						{getModalTitle(scimLog)}
					</Typography>
				}
				subTitle={
					<Typography size="paragraph-3" weight="regular">
						{getModalSubtitle(scimLog)}
					</Typography>
				}
				buttons={[
					<Button key="close-scim-details" testid="close-scim-details" color="blue" onClick={handleClose}>
						Close
					</Button>,
				]}
			>
				<div className={css.logDetailsContainer}>
					<FormattedLogDetails scimLog={scimLog} />
				</div>
			</ContentModal>
		);
	}
};

export default ScimDetailsModal;
